<template>
  <div class="px-3">
    <div class="row">
        <div class="btn-home  col-md-12 mt-2 mb-2 d-flex justify-content-end">
            <button type="button" class="btn btn-outline-main" @click="returnHome">
                <i class="fas fa-home-lg-alt"></i> Inicio
            </button>
        </div>
    </div>
    <div class="row d-flex">
      <div
        class="btn-home col-xl-12 col-lg-12 col-md-12 d-flex justify-content-start"
      >
        <ul class="nav" id="myTab" role="tablist">
          <li class="nav-item">
            <button
              @click="mtdSelectLab('trimax', 1)"
              :class="{
                'item-button': true,
                'nav-link': true,
                active: page === 'trimax',
              }"
              id="home-tab"
              type="button"
            >
              Trimax
            </button>
          </li>
          <li class="nav-item">
            <button
              @click="mtdSelectLab('topsa', 2)"
              :class="{
                'item-button': true,
                'nav-link': true,
                active: page === 'topsa',
              }"
              id="home-tab"
              type="button"
            >
              Topsa
            </button>
          </li>
          <li class="nav-item">
            <button
              @click="mtdSelectLab('mot', 2)"
              :class="{
                'item-button': true,
                'nav-link': true,
                active: page === 'mot',
              }"
              id="home-tab"
              type="button"
            >
              MOT
            </button>
          </li>
        </ul>
      </div>
    </div>
    <div class="row mx-0">
      <div class="tab-content" id="myTabContent">
        <Trimax
          v-if="page == 'trimax'"
          :lstBrand="lstBrand"
          :lstSubcategorie="lstSubcategorie"
          :lstDesing="lstDesing"
          :lstMaterial="lstMaterial"
          :lstRango="lstRango"
          :lstColor="lstColor"
        ></Trimax>
        <Topsa
          v-if="page == 'topsa'"
          :lstBrand="lstBrand"
          :lstSubcategorie="lstSubcategorie"
          :lstDesing="lstDesing"
          :lstMaterial="lstMaterial"
          :lstRango="lstRango"
          :lstColor="lstColor"
          :lstAdd="lstAdd"
          :lstHeight="lstHeight"
          :lstMaterialCod="lstMaterialCod"
        ></Topsa>
        <Mot
          v-if="page == 'mot'"
        ></Mot>
      </div>
    </div>
    <SweetAlert :swal="swal" ref="SweetAlert" />
  </div>
</template>

<script>
import { mapActions } from "vuex";
import SweetAlert from "@/components/shared/SweetAlert/SweetAlert.vue";
import Topsa from "../Laboratories/Topsa.vue";
import Trimax from "../Laboratories/Trimax.vue";
import Mot from "../Laboratories/Mot.vue";
export default {
  name: "c-maintenandce-pages-montaje",
  components: { SweetAlert, Trimax, Topsa,Mot },
  data() {
    return {
      page: "trimax",
      swal: null,
      lstBrand: [],
      lstSubcategorie: [],
      lstDesing: [],
      lstMaterial: [],
      lstRango:[],
      lstColor:[],
      lstAdd:[],
      lstHeight:[],
      lstMaterialCod:[]
    };
  },
  methods: {
    ...mapActions(["get", "post"]),
    returnHome: function () {
      this.$emit("returnHome");
    },
    mtdSelectLab: function (select, id) {
      this.page = select;
      this.mtdGetBrand(id);
    },
    mtdGetBrand: function (id) {
      this.get({
        url: this.$store.getters.get__url + "/montaje/getbrand/" + id,
        token: this.$store.getters.get__token,
      })
        .then((response) => {
          if (response.statusCode == 200) {
            this.lstBrand = response.data.brand;
            this.lstSubcategorie = response.data.subcategory;
            this.lstDesing = response.data.desing;
            this.lstMaterial = response.data.material;
            this.lstRango = response.data.rangos;
            this.lstColor=response.data.colors;
            this.lstAdd=response.data.add;
            this.lstHeight = response.data.height;
            this.lstMaterialCod = response.data.materialCod;
          }
        })
        .catch((errors) => {
          this.$refs.SweetAlert.showError(errors);
        });
    },
  },
};
</script>

<style lang="scss" scoped>
</style>